import { setInitialState } from "../../../utils/reducerOperations";

export function Default() {
  return {
    fetchUsersLogApi: setInitialState(),
    logsPagination: 1,
  };
}
